import React from 'react'

const Text = ({ text, textClass }) => <p className={`text-base leadig-5 font-normal ${textClass}`}>{text}</p>

export default Text
